export default function CategoryGrid() {
  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="mb-10 md:mb-14">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
              Shop by Category
            </h2>
            <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl">
              Browse Shoes, Hoodies, Apparel &amp; More — all available through our partner site Kaspreadsheet
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5 md:gap-6">
            {/* Shoes */}
            <a
              href="https://kaspreadsheet.com/category-911-Shoes.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Vibrant%20red%20running%20sneakers%20with%20white%20soles%20on%20light%20grey%20concrete%20surface%2C%20bright%20sunlight%20from%20overhead%2C%20dynamic%20sporty%20product%20photography%2C%20athletic%20lifestyle%20aesthetic%2C%20bold%20energy%2C%20professional%20sportswear%20catalog%20quality&width=800&height=800&seq=cat-v2-shoes&orientation=squarish"
                  alt="Shoes category - LitBuy Spreadsheet"
                  title="Shoes products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="eager"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Shoes</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Hoodies/Sweaters */}
            <a
              href="https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Thick%20mustard%20yellow%20hoodie%20hanging%20on%20wooden%20hanger%20against%20soft%20peach%20wall%2C%20warm%20afternoon%20window%20light%2C%20casual%20lifestyle%20photography%2C%20cozy%20autumn%20aesthetic%2C%20textured%20fabric%20visible%2C%20modern%20fashion%20boutique%20style&width=800&height=800&seq=cat-v2-hoodies&orientation=squarish"
                  alt="Hoodies/Sweaters category - LitBuy Spreadsheet"
                  title="Hoodies and Sweaters products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="eager"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Hoodies/Sweaters</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* T-Shirts */}
            <a
              href="https://kaspreadsheet.com/category-913-T-Shirts.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Sage%20green%20cotton%20t-shirt%20neatly%20folded%20on%20warm%20wooden%20tabletop%2C%20morning%20sunlight%20casting%20gentle%20shadows%2C%20minimal%20flat%20lay%20photography%2C%20organic%20natural%20vibe%2C%20soft%20earthy%20color%20palette%2C%20boutique%20clothing%20brand%20aesthetic&width=800&height=800&seq=cat-v2-tshirts&orientation=squarish"
                  alt="T-Shirts category - LitBuy Spreadsheet"
                  title="T-Shirts products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">T-Shirts</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Jackets */}
            <a
              href="https://kaspreadsheet.com/category-914-Jackets.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Deep%20burgundy%20leather%20jacket%20draped%20over%20rustic%20wooden%20chair%2C%20dramatic%20side%20lighting%20from%20large%20window%2C%20editorial%20fashion%20portrait%20style%2C%20rich%20textured%20material%2C%20luxurious%20urban%20aesthetic%2C%20high%20end%20fashion%20photography&width=800&height=800&seq=cat-v2-jackets&orientation=squarish"
                  alt="Jackets category - LitBuy Spreadsheet"
                  title="Jackets products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Jackets</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Pants/Shorts */}
            <a
              href="https://kaspreadsheet.com/category-915-Pants%2FShorts.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Navy%20blue%20tailored%20trousers%20hanging%20on%20minimal%20metal%20rack%20against%20white%20brick%20wall%2C%20clean%20studio%20lighting%2C%20contemporary%20retail%20display%20photography%2C%20sharp%20professional%20aesthetic%2C%20modern%20workwear%20style%2C%20crisp%20textile%20texture%20visible&width=800&height=800&seq=cat-v2-pants&orientation=squarish"
                  alt="Pants/Shorts category - LitBuy Spreadsheet"
                  title="Pants and Shorts products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Pants/Shorts</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Headwear */}
            <a
              href="https://kaspreadsheet.com/category-916-Headwear.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Charcoal%20grey%20beanie%20hat%20resting%20on%20smooth%20marble%20surface%20with%20winter%20pine%20branch%20beside%2C%20soft%20diffused%20daylight%2C%20cozy%20winter%20accessories%20photography%2C%20Scandinavian%20minimalist%20aesthetic%2C%20textured%20knit%20detail%2C%20seasonal%20fashion%20catalog&width=800&height=800&seq=cat-v2-headwear&orientation=squarish"
                  alt="Headwear category - LitBuy Spreadsheet"
                  title="Headwear products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Headwear</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Sets */}
            <a
              href="https://kaspreadsheet.com/category-917-Sets.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Coordinated%20cream%20linen%20shirt%20and%20shorts%20set%20artfully%20arranged%20on%20rattan%20surface%2C%20tropical%20sunlight%20filtering%20through%20leaves%2C%20vacation%20resort%20lookbook%20photography%2C%20breezy%20summer%20aesthetic%2C%20natural%20fabric%20texture%2C%20luxury%20holiday%20fashion&width=800&height=800&seq=cat-v2-sets&orientation=squarish"
                  alt="Sets category - LitBuy Spreadsheet"
                  title="Sets products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Sets</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Underwear/Underpants */}
            <a
              href="https://kaspreadsheet.com/category-918-underwear%2Funderpants.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Soft%20pale%20pink%20cotton%20underwear%20delicately%20folded%20on%20white%20linen%20fabric%20with%20dried%20lavender%20sprigs%2C%20gentle%20morning%20window%20light%2C%20romantic%20boudoir%20photography%2C%20feminine%20soft%20aesthetic%2C%20clean%20intimate%20apparel%20catalog&width=800&height=800&seq=cat-v2-underwear&orientation=squarish"
                  alt="Underwear/Underpants category - LitBuy Spreadsheet"
                  title="Underwear and Underpants products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Underwear/Underpants</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Jersey */}
            <a
              href="https://kaspreadsheet.com/category-919-Jersey.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Emerald%20green%20soccer%20jersey%20with%20white%20stripes%20laid%20flat%20on%20artificial%20grass%20texture%2C%20stadium%20floodlight%20style%20illumination%2C%20dynamic%20sports%20photography%2C%20energetic%20athletic%20vibe%2C%20professional%20team%20sportswear%20catalog%2C%20vibrant%20color%20contrast&width=800&height=800&seq=cat-v2-jersey&orientation=squarish"
                  alt="Jersey category - LitBuy Spreadsheet"
                  title="Jersey products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Jersey</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Accessories */}
            <a
              href="https://kaspreadsheet.com/category-920-Accessories.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Gold%20toned%20watch%20and%20layered%20chain%20necklace%20displayed%20on%20dark%20slate%20stone%20surface%20with%20single%20orchid%20bloom%2C%20luxury%20jewelry%20lighting%20with%20sparkle%20catchlights%2C%20high%20end%20accessories%20photography%2C%20elegant%20sophisticated%20mood&width=800&height=800&seq=cat-v2-accessories&orientation=squarish"
                  alt="Accessories category - LitBuy Spreadsheet"
                  title="Accessories products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Accessories</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Bags */}
            <a
              href="https://kaspreadsheet.com/category-921-Bags.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Coral%20pink%20canvas%20backpack%20leaning%20against%20white%20shiplap%20wall%20with%20monstera%20leaf%20shadow%2C%20bright%20natural%20daylight%2C%20urban%20lifestyle%20photography%2C%20fresh%20youthful%20aesthetic%2C%20trendy%20accessories%20catalog%2C%20clean%20modern%20composition&width=800&height=800&seq=cat-v2-bags&orientation=squarish"
                  alt="Bags category - LitBuy Spreadsheet"
                  title="Bags products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Bags</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* Belts */}
            <a
              href="https://kaspreadsheet.com/search-922/name/Bags.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="relative w-full aspect-[4/3] overflow-hidden bg-background-200">
                <img
                  src="https://readdy.ai/api/search-image?query=Braided%20cognac%20leather%20belt%20with%20antique%20brass%20buckle%20displayed%20on%20weathered%20dark%20wood%20plank%2C%20side%20window%20lighting%20creating%20long%20dramatic%20shadows%2C%20rustic%20artisan%20photography%2C%20heritage%20craftsmanship%20aesthetic%2C%20rich%20warm%20textures&width=800&height=800&seq=cat-v2-belts&orientation=squarish"
                  alt="Belts category - LitBuy Spreadsheet"
                  title="Belts products at Kaspreadsheet"
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Belts</h3>
                <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                <div className="mt-3">
                  <span className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>
          </div>

          {/* Bottom row: Perfumes + OtherStuff */}
          <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6">
            {/* Perfumes */}
            <a
              href="https://kaspreadsheet.com/search-923/name/Bags.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="flex items-center gap-5 p-4 md:p-5">
                <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Amber%20glass%20perfume%20bottle%20with%20gold%20cap%20on%20black%20velvet%20cloth%20with%20rose%20petals%20scattered%2C%20dramatic%20spotlight%20illumination%2C%20luxury%20fragrance%20photography%2C%20sensual%20mysterious%20mood%2C%20premium%20perfume%20advertisement%20style&width=800&height=800&seq=cat-v2-perfumes&orientation=squarish"
                    alt="Perfumes category - LitBuy Spreadsheet"
                    title="Perfumes products at Kaspreadsheet"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">Perfumes</h3>
                  <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                  <span className="inline-flex items-center gap-1 mt-2 text-sm font-medium text-primary-600 whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>

            {/* OtherStuff */}
            <a
              href="https://kaspreadsheet.com/search-924/name/Bags.html"
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-lg overflow-hidden transition-all duration-300 hover:scale-[1.02] cursor-pointer"
              data-product-shop
            >
              <div className="flex items-center gap-5 p-4 md:p-5">
                <div className="relative w-20 h-20 md:w-24 md:h-24 rounded-lg overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src="https://readdy.ai/api/search-image?query=Eclectic%20mix%20of%20colorful%20sunglasses%20scarves%20and%20phone%20cases%20scattered%20on%20bright%20yellow%20background%2C%20playful%20pop%20art%20style%20lighting%2C%20fun%20vibrant%20product%20photography%2C%20energetic%20youthful%20aesthetic%2C%20miscellaneous%20fashion%20items%20collection&width=800&height=800&seq=cat-v2-other&orientation=squarish"
                    alt="OtherStuff category - LitBuy Spreadsheet"
                    title="OtherStuff products at Kaspreadsheet"
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div>
                  <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors">OtherStuff</h3>
                  <p className="mt-1 text-xs text-foreground-400">Available at Kaspreadsheet</p>
                  <span className="inline-flex items-center gap-1 mt-2 text-sm font-medium text-primary-600 whitespace-nowrap">
                    View Collection <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line text-sm"></i></span>
                  </span>
                </div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}